import { render } from "./FormTree.vue?vue&type=template&id=255e8f1d&ts=true"
import script from "./FormTree.vue?vue&type=script&lang=ts"
export * from "./FormTree.vue?vue&type=script&lang=ts"

import "./FormTree.vue?vue&type=style&index=0&id=255e8f1d&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__